import moment from 'moment';
import 'moment/locale/en-gb';

const groupImpactsByPeriod = (data, groupBy, selectedDateRange) => {
  const excludedStatus = ['Cancelled', 'On Hold', 'Rejected'];
  const groupedAll = {};
  const groupedActive = {};

  if (groupBy === 'None') {
    return { groupedAll, groupedActive };
  }

  const getFiscalYears = () => ['FY 2023/24', 'FY 2024/25', 'FY 2025/26', 'FY 2026/27', 'FY 2027/28'];
  const getMonths = (year) => {
    const yearPart = year.split(' ')[1];
    const startYear = parseInt(yearPart.split('/')[0]);
    const monthNames = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    return Array.from({ length: 12 }, (_, i) => {
      const monthIndex = (6 + i) % 12;
      const currentYear = startYear + (i < 6 ? 0 : 1);
      return `${monthNames[monthIndex]}-${currentYear}`;
    });
  };

  const getQuarters = (year) => {
    const yearPart = year.split(' ')[1];
    const startYear = parseInt(yearPart.split('/')[0]);
    const endYear = startYear + 1;
    return [`FY ${startYear}/${String(endYear).slice(-2)} Q1`, `FY ${startYear}/${String(endYear).slice(-2)} Q2`, `FY ${startYear}/${String(endYear).slice(-2)} Q3`, `FY ${startYear}/${String(endYear).slice(-2)} Q4`];
  };

  const getMonthIndexForDate = (date) => {
    const mDate = moment(date);
    const startOfFY23 = moment('2023-07-01');
    return mDate.diff(startOfFY23, 'months');
  };

  const aggregateValues = (period, index, monthlyValues, isActive, source) => {
    if (index >= 0 && index < 60) {
      if (!source[period]) {
        source[period] = { plan: 0, actual: 0, estimate: 0, forecast: 0 };
      }
      for (const key in monthlyValues) {
        const value = Number(monthlyValues[key][index]) || 0;
        source[period][key] += value;
      }
    }
  };

  const allFiscalYears = getFiscalYears();
  const allQuarters = allFiscalYears.flatMap(getQuarters);
  const allMonths = allFiscalYears.flatMap(getMonths);

  data.forEach((initiative) => {
    const impact = initiative.impact || [];
    const isActiveInitiative = !excludedStatus.includes(initiative.weeklyStatus);

    impact.forEach((singleImpact) => {
      const monthlyPlan = Array.isArray(singleImpact.monthlyPlan) ? singleImpact.monthlyPlan : Array(60).fill(0);
      const monthlyActual = Array.isArray(singleImpact.monthlyActual) ? singleImpact.monthlyActual : Array(60).fill(0);
      const monthlyEstimate = Array.isArray(singleImpact.monthlyEstimate) ? singleImpact.monthlyEstimate : Array(60).fill(0);
      const monthlyForecast = Array.isArray(singleImpact.monthlyForecast) ? singleImpact.monthlyForecast : Array(60).fill(0);
      const monthlyValues = {
        plan: monthlyPlan,
        actual: monthlyActual,
        estimate: monthlyEstimate,
        forecast: monthlyForecast,
      };
      if (!selectedDateRange || selectedDateRange.length !== 2) {
        let periods = [];
        if (groupBy === 'year') {
          periods = allFiscalYears;
        } else if (groupBy === 'quarter') {
          periods = allQuarters;
        } else if (groupBy === 'month') {
          periods = allMonths;
        }

        periods.forEach((period, index) => {
          aggregateValues(period, index, monthlyValues, true, groupedAll);
          if (isActiveInitiative) {
            aggregateValues(period, index, monthlyValues, true, groupedActive);
          }
        });
      } else {
        const [startDate, endDate] = selectedDateRange;
        let currentMonth = moment(startDate).startOf('month');
        const endMoment = moment(endDate).endOf('month');

        while (currentMonth.isSameOrBefore(endMoment, 'month')) {
          const monthIndex = getMonthIndexForDate(currentMonth);
          if (monthIndex >= 0 && monthIndex < 60) {
            let period;
            if (groupBy === 'year') {
              const yearOffset = Math.floor(monthIndex / 12);
              const startYear = 2023 + yearOffset;
              const endYear = startYear + 1;
              period = `FY ${startYear}/${String(endYear).slice(-2)}`;
            } else if (groupBy === 'quarter') {
              const quarterIndex = Math.floor((monthIndex % 12) / 3);
              const yearOffset = Math.floor(monthIndex / 12);
              const startYear = 2023 + yearOffset;
              const endYear = startYear + 1;
              period = `FY ${startYear}/${String(endYear).slice(-2)} Q${quarterIndex + 1}`;
            } else if (groupBy === 'month') {
              period = allMonths[monthIndex];
            }

            if (period) {
              if (!groupedAll[period]) {
                groupedAll[period] = { plan: 0, actual: 0, estimate: 0, forecast: 0 };
              }
              if (isActiveInitiative && !groupedActive[period]) {
                groupedActive[period] = { plan: 0, actual: 0, estimate: 0, forecast: 0 };
              }

              for (const key in monthlyValues) {
                const value = Number(monthlyValues[key][monthIndex]) || 0;
                groupedAll[period][key] += value;
                if (isActiveInitiative) {
                  groupedActive[period][key] += value;
                }
              }
            }
          }
          currentMonth.add(1, 'month');
        }
      }
    });
  });
  return { groupedAll, groupedActive };
};

export default groupImpactsByPeriod;